import React, { useEffect, useState } from 'react';
import { FormLayout, TextInput, useFormContainer } from '../common';
import { get, handleResponse, swal500, patch, handle400 } from '../../utils/network';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify/dist/react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ENTITY_PROPS = {
    entityName: 'configuracion',
    endpoint: 'config',
    path: '/home/config',
};

const INITIAL_STATE = {
    extension: '',
    maxFileSize: 10000000
};

const MESSAGES = {
    title: 'Configuraciones',
    created: 'La configuracion se ha guardado correctamente',
    edited: 'La configuracion se ha editado correctamente',
    deleted: '',
    deleteConfirmation: document => ``,
};

const FIELDS = {
    extension: 'Extensiones excluidas',
    maxFileSize: 'Tamanio maximo de archivo (Bytes)'
};

const Config = ({ history }) => {
    const { entityName, endpoint, path } = ENTITY_PROPS;

    const {
        data,
        setData,
        loading,
        setLoading,
        submitting,
        setSubmitting,
        handleClose,
        handleCancel,
    } = useFormContainer(ENTITY_PROPS, () => { }, MESSAGES.deleteConfirmation());

    const [localValues, setLocalValues] = useState(INITIAL_STATE);


    useEffect(() => {
        if(window.RUNTIME_CONFIG != undefined){
            console.log("URL Configuration:")
            console.log(window.RUNTIME_CONFIG.APP_URL); // Logs the runtime APP_URL
            console.log(window.RUNTIME_CONFIG.API_URL); // Logs the runtime API_URL
        }else{
            console.log("No URL Configuration detected, using default")
        }
        const getConfig = () => {
            setLoading(true);
            get(`${endpoint}`)
                .then(res => handleResponse(res, { history }))
                .then(resConfig => {
                    if (resConfig && resConfig.message && resConfig.message.data && resConfig.message.data[0] && resConfig.message.data[0].config) {
                        setData(resConfig.message);
                        const extensions = resConfig.message.data[0].config.extensions.join(', ');
                        const maxFileSize = resConfig.message.data[0].config.maxFileSize;
                        setLocalValues({ extension: extensions, maxFileSize: maxFileSize });
                    } else {
                        throw new Error("Invalid response structure");
                    }
                })
                .then(() => history.push({ pathname: path, state: { msg: 'edited' } }))
                .catch(err => {
                    swal500(err);
                    history.push(path);
                })
                .finally(() => setLoading(false));
        };

        getConfig();
    }, [endpoint, history, path, setData, setLoading]);

    const handleChangeLocal = (event) => {
        const { name, value } = event.target;
        setLocalValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    };

    const hasChanges = () => {
        const changedValues = Object.keys(localValues).filter(key => localValues[key] !== data[key]);
        return changedValues.length > 0;
    };

    const handleResult = e => {
        e.preventDefault();
        setSubmitting(true);
        const requestBody = {
            config: {
                extensions: localValues.extension.split(', ').map(ext => ext.trim()),
                maxFileSize: localValues.maxFileSize
            }
        };
        patch(`${endpoint}`, requestBody)
            .then(res =>
                handleResponse(res, { history }, [
                    { status: 400, method: handle400(FIELDS, () => { }) },
                ])
            )
            .then(() => {
                toast.info('Configuración guardada correctamente', {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "light"
                  });
            })
            .catch(err => err !== 400 && swal500(err))
            .finally(() => setSubmitting(false));
    };
    
    return (
        <FormLayout
            handleClose={handleClose}
            loading={loading}
            editMode={true}
            submitting={submitting}
            handleSubmit={handleResult}
            handleCancel={handleCancel}
            handleEdit={false}
            isNew={false}
            entityName={entityName}
            hasChanges={hasChanges}
            hideCancelButton={true}
            withBackButton={false}
        >
            <ToastContainer />
            <TextInput
                name="extension"
                value={localValues.extension}
                handleChange={handleChangeLocal}
                label={FIELDS['extension']}
                disabled={false}
            />
            <TextInput
                name="maxFileSize"
                value={localValues.maxFileSize}
                handleChange={handleChangeLocal}
                label={FIELDS['maxFileSize']}
                disabled={false}
            />
        </FormLayout>
    );
};

export default Config;

